export default __webpack_public_path__ + "static/media/swagup_Logo_with_Name.08f2bd3e.svg";